import { TYPE_SIZES as e } from "../../utils/index.js";
import { openBlock as t, createElementBlock as a, normalizeClass as o, createElementVNode as r } from "vue";
import "./index2.js";
import l from "../../_virtual/index.js";
const i = {
  name: "Loader",
  props: {
    size: {
      type: String,
      default: e.normal.value
    },
    isWhite: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    rootClass() {
      return {
        [e.small.className]: this.size === e.small.value,
        [e.large.className]: this.size === e.large.value,
        _white: this.isWhite
      };
    }
  }
}, c = /* @__PURE__ */ r("div", { class: "b24-loader__circle" }, null, -1), n = [
  c
];
function m(d, _, p, u, f, s) {
  return t(), a("div", {
    class: o(["b24-loader", s.rootClass])
  }, n, 2);
}
const g = /* @__PURE__ */ l(i, [["render", m]]);
export {
  g as default
};
